import { useEffect, useRef } from 'react';
import { DO_NOT_DISPLAY_THREAD } from 'copilot-toolkit/constants/PromptThread';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionsRenderer = ({
  message,
  actionFn
}) => {
  const wasStreamingRef = useRef(false);
  const wasSentRef = useRef(false);
  useEffect(() => {
    if ('streamingState' in message && message.streamingState === 'streaming') {
      wasStreamingRef.current = true;
      return;
    }
    if (wasSentRef.current || !wasStreamingRef.current) {
      return;
    }
    wasSentRef.current = true;
    if ('message' in message) {
      actionFn({
        actionType: 'send_message_to_app',
        message: message.message,
        userThread: DO_NOT_DISPLAY_THREAD
      });
    }
  }, [actionFn, message]);
  return null;
};
export const RemixPlugin = {
  gate: 'Copilot:Collaborate',
  // Dummy intent to use for remix
  intentTypes: ['remix_refine'],
  collaborateCopilotMessageTypes: ['THIS_PROP_IS_SILLY'],
  sectionRenderer: (__message, __MarkdownComponent) => {
    return /*#__PURE__*/_jsx("div", {
      children: "Working on it..."
    });
  },
  actionsRenderer: ActionsRenderer
};